export default {
      id: "ic_uniform-usage",
      viewBox: "0 0 28 28",
      url: "/" + "images/icons.3.109.2.svg#ic_uniform-usage",
      toString: function () {
        return this.url;
      }
    }